export default "__VITE_ASSET__Ch5kB2mJ__"